import batteryIcon from 'assets/images/sprite/battery-white-icon.svg'
import brainIcon from 'assets/images/sprite/brain-white-icon.svg'
import lightningIcon from 'assets/images/sprite/lightning-white-icon.svg'
import moonSleepIcon from 'assets/images/sprite/moon-sleep-white-icon.svg'
import stomachIcon from 'assets/images/sprite/stomach-white-icon.svg'

export const EARLY_SIGNS = [
  {
    icon: moonSleepIcon,
    titleKey: 'onboarding.landingWellness.earlySigns.fatigue.title',
    descriptionKey: 'onboarding.landingWellness.earlySigns.fatigue.description',
  },
  {
    icon: stomachIcon,
    titleKey: 'onboarding.landingWellness.earlySigns.digestion.title',
    descriptionKey:
      'onboarding.landingWellness.earlySigns.digestion.description',
  },
  {
    icon: lightningIcon,
    titleKey: 'onboarding.landingWellness.earlySigns.aches.title',
    descriptionKey: 'onboarding.landingWellness.earlySigns.aches.description',
  },
  {
    icon: brainIcon,
    titleKey: 'onboarding.landingWellness.earlySigns.brainFog.title',
    descriptionKey:
      'onboarding.landingWellness.earlySigns.brainFog.description',
  },
  {
    icon: batteryIcon,
    titleKey: 'onboarding.landingWellness.earlySigns.energyCrashes.title',
    descriptionKey:
      'onboarding.landingWellness.earlySigns.energyCrashes.description',
  },
] as const
